import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Agenda } from './components/Agenda';
import { Topics } from './components/Topics';
import { Experience } from './components/Experience';
import { Registration } from './components/Registration';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Topics data-id="element-5" />
        <Agenda data-id="element-6" />
        <Experience data-id="element-7" />
        <Registration data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}